export * from './lib/permission-settings.module';
export { permissionsList } from './lib/permission-settings.model';
